import React from 'react';
import { Scroll } from '../../layout_components/scroll';
import { SearchBar } from '../../search_bar';

import { Body, Center, Container, Header, Item, List, Title } from './styles';

export interface ItemProps<t> {
  id: number;
  label: string;
  data: t;
}

export interface ModalProps<t> {
  title: string;
  items: ItemProps<t>[];
  onSelectItem: (item: ItemProps<t>) => void;
  onCloseModal: () => void;
}

const ModalSelect: React.FC<ModalProps<any>> = (props) => {
  const [searchTerm, setSearchTerm] = React.useState('');

  const handleSearch = () => {
    return props.items
      ? props.items.filter((item) => item.label?.toLowerCase().includes(searchTerm.toLowerCase()))
      : [];
  };

  return (
    <Center onClick={props.onCloseModal}>
      <Container onClick={(e) => e.stopPropagation()}>
        <Header>
          <Title>{props.title}</Title>
          <SearchBar onSearch={setSearchTerm} autoFocus />
        </Header>
        <Body>
          <Scroll>
            <List>
              {handleSearch().map((item) => (
                <Item key={item.id} onClick={() => props.onSelectItem(item)}>
                  {item.label}
                </Item>
              ))}
            </List>
          </Scroll>
        </Body>
      </Container>
    </Center>
  );
};

export { ModalSelect };
